export const CoordLocationConstants = {
    GET_COORD_LOC: 'GET_COORD_LOC',
    SET_COORD_LOC: 'SET_COORD_LOC'
};